export const parseCurrencyToNumber = (value: string): number | null => {
  if (!value || value === '.') return null
  const cleanValue = value.replace(/[^0-9.]/g, '')
  const parsed = parseFloat(cleanValue)
  return isNaN(parsed) ? null : parsed
}

export const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return ''
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

interface FormatCurrencyWithDollarSignOptions {
  numberOfDecimalsForM?: number
  numberOfDecimalsForK?: number
  showDollarSign?: boolean
}

export const formatCurrencyWithDollarSign = (
  value: number | null | undefined,
  {
    numberOfDecimalsForM = 0,
    numberOfDecimalsForK = 0,
    showDollarSign = true,
  }: FormatCurrencyWithDollarSignOptions = {},
): string => {
  if (value === null || value === undefined) return ''
  const currency = showDollarSign ? '$' : ''
  if (value >= 1000000) return `${currency}${(value / 1000000).toFixed(numberOfDecimalsForM)}M`
  if (value >= 1000) return `${currency}${(value / 1000).toFixed(numberOfDecimalsForK)}K`
  return `${currency}${value.toFixed(0)}`
}
